/**
 * @file 使用对象原始地址
 * @description 缓存对象引用，只有深比较发生改变时再更新，否则使用缓存
 * @author alfielv
 */
import _ from 'lodash';
import { useRef } from 'react';
export default (function (state) {
  var previousRef = useRef(state); // 深比较当前值与缓存值，发生改变再更新缓存值

  if (!_.isEqual(previousRef.current, state)) {
    previousRef.current = state;
  } // 返回缓存值


  return previousRef.current;
});